import { Anchor, Text } from '@zillow/constellation-10';

import type { TextPropsInterface } from '@zillow/constellation-10';

type Text = {
  text: string;
  styling?: string;
  url?: string;
};

type Props = {
  styledTextList: Array<Text>;
  fontColor?: TextPropsInterface['color'];
};

const TEXT_STYLING = {
  legal: 'fineprint',
  normal: 'body-sm',
  emphasize: 'body-sm-bold',
} as const;

const InlineStyledText = ({ styledTextList = [], fontColor = 'text.subtle' }: Props) => {
  const getInnerText = ({ text, url }: Text) => {
    if (url) {
      return <Anchor href={url}>{text}</Anchor>;
    }

    return text;
  };

  if (!styledTextList || !styledTextList.length) {
    return null;
  }

  return (
    <div data-test="inline-styled-text">
      {styledTextList.map((styledText, index) => (
        <Text
          key={`inlinedStyledText-${index}`}
          textStyle={styledText.styling ? TEXT_STYLING[styledText.styling as keyof typeof TEXT_STYLING] : 'body'}
          color={fontColor}
        >
          {getInnerText(styledText)}
        </Text>
      ))}
    </div>
  );
};

export default InlineStyledText;
